import axios from "axios";
import { baseUrl } from "../config/api-config";

const base = `${baseUrl}/auth`;

export function fetchTokenUser(token) {
  return axios.get(base + "/user", {
    headers: {
      Authorization: token,
    },
  });
}

export function emailLogin(email, password) {
  return axios.post(base + "/login", { email, password });
}

export function forgetPassword(email) {
  return axios.post(base + "/forget-password", { email });
}

export function resetPassword(email, otp, newPassword) {
  return axios.post(base + "/reset-password", { email, otp, newPassword });
}

export function microsoftCallback(query) {
  return axios.get(base + "/outlook/callback" + query);
}
export function enableMfa(token) {
  return axios.post(
    `${base}/sign-up-mfa`,
    {},
    {
      headers: {
        authorization: `${token}`,
      },
    }
  );
}

export function validateMfa(otp, token) {
  return axios.post(
    `${base}/validate-mfa`,
    { otp },
    {
      headers: {
        authorization: `${token}`,
      },
    }
  );
}

export function validateMfaLogin(email, otp) {
  return axios.post(`${base}/validate-mfa-login`, { otp, email });
}
export function teamsLogin(token) {
  return axios.get(base + "/msteams", {
    headers: {
      authorization: token,
    },
  });
}

export function teamsCallback(query, token) {
  return axios.get(base + "/teams/callback" + query, {
    headers: {
      authorization: token,
    },
  });
}
